export const AREA = 'local-notifications-settings';
